import * as React from 'react';
import { observer } from 'mobx-react';
function HiddenContainer(props) {
    const { field } = props;
    return React.createElement("input", { type: 'hidden', value: field.getValue(), required: field.isRequired, onChange: (event) => field.setValue(event.currentTarget.value) });
}
export default observer(HiddenContainer);
//# sourceMappingURL=Hidden.js.map